<template lang="pug">
v-app.directory
  bar-and-nav
  v-main.main.ma-4
    h3.black--text Dashboards
    ul
      li(v-for="item in data")
        a(:href="`/${item.slug}`") {{item.title}}
  v-footer(color="#005cb8")
    p.ma-auto.white--text.body-2 Copyright © {{new Date().getFullYear()}} Arlington County Virginia
</template>

<script>
import BarAndNav from '@/components/BarAndNav.vue'
import config from '@/config'

export default {
  components: {
    BarAndNav
  },
  data: () => ({
    data: []
  }),
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      let response = await fetch(`${config.strapiBase}/dashboards`)
      let json = await response.json()
      this.data = json
    }
  }
}
</script>

<style lang="stylus">
.directory
  .main
    position: absolute
</style>